import Nav from './nav';

export default class NavFooter extends Nav {
  constructor() {
    super();
    this.selector = '.nav-footer';

    this.selectors = {
      subMenu: '.nav-footer .sub-menu',
    };
  }

  bootstrap() {
    this.init();
  }
}
